// services/ModuleService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

export function getModules(params = {}) {
    return api.get(ENDPOINTS.MODULES.BASE, { params });
}
export function getModuleById(id) {
    return api.get(ENDPOINTS.MODULES.BY_ID(id));
}
export function createModule(payload) {
    return api.post(ENDPOINTS.MODULES.BASE, payload);
}
export function updateModule(id, payload) {
    return api.patch(ENDPOINTS.MODULES.BY_ID(id), payload);
}
export function deleteModule(id) {
    return api.delete(ENDPOINTS.MODULES.BY_ID(id));
}
export function restoreModule(id) {
    return api.post(`${ENDPOINTS.MODULES.BY_ID(id)}/restore`);
}
